"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPingback = void 0;
var js_util_1 = require("@giphy/js-util");
// TODO remove api key
var pingBackUrl = 'https://pingback.giphy.com/v2/pingback?apikey=l0HlIwPWyBBUDAUgM';
exports.sendPingback = function (events) {
    var headers = js_util_1.getGiphySDKRequestHeaders();
    /* istanbul ignore next */
    headers === null || headers === void 0 ? void 0 : headers.set('Content-Type', 'application/json');
    js_util_1.Logger.debug("Pingback session", events);
    return fetch(pingBackUrl, {
        method: 'POST',
        body: JSON.stringify({ events: events }),
        headers: headers,
    });
};
//# sourceMappingURL=send-pingback.js.map